<template>
  <main-content with_go_back_bar>
    <kt-panel>
      <kt-panel-body>
        <News-form v-if="status !== 'loading'" :submit="updateNews" :query="form_data"></News-form>
      </kt-panel-body>
    </kt-panel>
  </main-content>
</template>

<script>
import $ from "jquery";
import { KTApp } from "@/plugins/core/app";
import { KTUtil } from "@/plugins/core/util";
import { newsService } from "@/common/api.service";
import NewsForm from "./components/form";
import mainContent from "@/components/main-content";
import { mapGetters } from "vuex";

export default {
  components: {
    NewsForm,
    mainContent,
  },
  computed: {
    ...mapGetters("news", ["status", "form_data"]),
  },
  data() {
    return {
      hashid: this.$route.params.hashid,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("news/find", vm.hashid);
    });
  },

  methods: {
    updateNews(e, query) {
      let form = $(e.target);
      let btn = $("#submit_btn");

      form.validate({
        rules: {
          subject: {
            required: true,
          },
          newscontent: {
            required: true,
          },
        },
      });

      if (!form.valid()) {
        return;
      }

      KTApp.progress(btn);
      newsService
        .update(this.hashid, query)
        .then((response) => {
          this.$router.push("/news");
          this.showMsg(form, "success", response.data.message);
        })
        .catch(({ response }) => {
          if (response.data) {
            form.validate().showErrors(response.data.data);
          }
          this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {
          KTUtil.scrollTop();
          KTApp.unprogress(btn);
        });
    },
  },
};
</script>